import * as React from 'react';

import type { SupplierAnnouncementsClient } from '@/api/supplier-announcements-client';
import { HttpSupplierAnnouncementsClient } from '@/api/supplier-announcements-client.http';

// =============================================================================
// supplier-announcements-client-context.tsx — Injection du SupplierAnnouncementsClient (DI seam, R15-COM-07).
// =============================================================================
// Permet de substituer le client (double déterministe en test, impl HTTP réelle en prod) sans toucher l'UI.
// Par défaut : l'adaptateur HTTP RÉEL — le BACK réception d'annonces est livré (COM-07). Câblé HTTP DÈS LE
// DÉPART (garde 09_stub_in_prod_guard : aucun défaut stub-en-prod). Les tests injectent un
// StubSupplierAnnouncementsClient via le provider.

/** Adaptateur par défaut : HTTP réel (chemins relatifs racine API, cookie de session fournisseur). */
const defaultSupplierAnnouncementsClient: SupplierAnnouncementsClient =
  new HttpSupplierAnnouncementsClient();

const SupplierAnnouncementsClientContext =
  React.createContext<SupplierAnnouncementsClient>(defaultSupplierAnnouncementsClient);

export interface SupplierAnnouncementsClientProviderProps {
  client?: SupplierAnnouncementsClient | undefined;
  children: React.ReactNode;
}

export function SupplierAnnouncementsClientProvider({
  client = defaultSupplierAnnouncementsClient,
  children,
}: SupplierAnnouncementsClientProviderProps): React.JSX.Element {
  return (
    <SupplierAnnouncementsClientContext.Provider value={client}>
      {children}
    </SupplierAnnouncementsClientContext.Provider>
  );
}

export function useSupplierAnnouncementsClient(): SupplierAnnouncementsClient {
  return React.useContext(SupplierAnnouncementsClientContext);
}
